import { Formik, FormikValues, useFormikContext } from 'formik';
import {
  Dialog,
  isMobile,
  isDesktop,
  DialogType,
  ButtonTypes,
  ButtonColors,
  StandardButton,
  ButtonStyleTypes,
  StandardButtonWithRef,
} from '@gv/triage-components';

import { InternalReportField } from 'components';

import * as Styles from './styles';
import { FormValues } from './types';
import { getInitialValues } from './config';

export const SubmitStep = () => {
  const mobile = isMobile();
  const desktop = isDesktop();
  const { values, setValues } = useFormikContext<FormikValues>();
  return (
    <div>
      Please click submit if consultation is finished. If you have any technical
      issues please report using internal reporting found{' '}
      <Dialog
        title="Internal reporting"
        closeOnDocumentClick={false}
        width={desktop ? '760px' : '90vw'}
        trigger={
          <StandardButtonWithRef
            transparent
            padding="0"
            text="here."
            styleType={ButtonStyleTypes.Ghost}
          />
        }
      >
        {(close, _, Buttons) => (
          <Formik
            initialValues={getInitialValues(values)}
            onSubmit={(formValues: FormValues) => {
              setValues((prevValues) => ({ ...prevValues, ...formValues }));
              close();
            }}
          >
            {({ dirty, isSubmitting }) => (
              <Styles.Form>
                <InternalReportField />

                <Buttons type={DialogType.Plain}>
                  <StandardButton
                    text="Close"
                    onClick={close}
                    fullWidth={mobile}
                  />
                  <StandardButton
                    text="Confirm"
                    fullWidth={mobile}
                    type={ButtonTypes.Submit}
                    disabled={!dirty || isSubmitting}
                    colorType={ButtonColors.LightBlue}
                  />
                </Buttons>
              </Styles.Form>
            )}
          </Formik>
        )}
      </Dialog>
    </div>
  );
};
